import React from 'react';
import { connect } from 'react-redux';

import { sendRequest, triggerEvent } from '../../helpers/global.js';

import '../../sass/components/common/UnlockDialog.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
    venues: store.data.venues || [],
  }
};

class UnlockDialog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  onContact = () => {
    const notBeyond = (this.props.user.venues || [])
      .filter(i => !i.beyond_partner)
      .map(i => i.id);
    const desired = this.props.venues.filter(i => notBeyond.includes(i));
    sendRequest({
      method: 'venues/beyond_request',
      type: 'POST',
      data: {
        venue_ids: desired,
      },
      success: (data) => {
        triggerEvent('showSnackbar', [{text: 'Success! We’ll get in touch with you soon.'}]);
      },
      error: (data) => {
      }
    });
  }

  render = () => {
    return (
      <div className='unlockDialog'>
        <div className='beyondLogo'/>
        <div className='illustration'/>
        <div className='unlockTitle'>
          Unlock more insights with Burpple Beyond
        </div>
        <div className='unlockDescription'>
          Join our network of 500+ partners in offering 1-for-1 deals 
          and get access to useful stats like New vs Returning customers, 
          drop off rates and customer feedback.
          <br/>
          Keen to find out more? Contact us and we’ll be in touch as 
          soon as possible!
        </div>
        <button onClick={this.onContact}>Contact us</button>
      </div>
    )
  }
}

export default connect(mapStoreToProps)(UnlockDialog);
